import type {
  CreateRoomRequest, CreateRoomResponse,
  JoinRoomRequest, JoinRoomResponse,
  VoteRequest, VoteResponse,
  GetRoomResponse,
} from "../shared/contracts";

async function post<T>(url: string, body: unknown): Promise<T> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json() as Promise<T>;
}

export function createRoom(body: CreateRoomRequest): Promise<CreateRoomResponse> {
  return post("/api/rooms", body);
}

export function getRoom(code: string): Promise<GetRoomResponse> {
  return fetch(`/api/rooms/${code}`).then(async r => {
    if (!r.ok) throw new Error(await r.text());
    return r.json() as Promise<GetRoomResponse>;
  });
}

export function joinRoom(code: string, body: JoinRoomRequest): Promise<JoinRoomResponse> {
  return post(`/api/rooms/${code}/join`, body);
}

export function castVote(code: string, body: VoteRequest): Promise<VoteResponse> {
  return post(`/api/rooms/${code}/vote`, body);
}
